export default {
  home: "Home",
  gameDev: "Game Development",
  mobileApp: "Mobile App",
  webApp: "Web App",
  webDev: "Web Development",
  projects: {
    firstsleep: "Firstsleep",
    xways: "X-Ways",
    mercul: "Mercul",
    vidus: "Vidus video call"
  },
  policy: "Privacy Policy",
  contactUs: "Contact Us"
};
